import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import { typography } from 'src/config/typography';
import React, { FC } from 'react';
import { Button } from 'src/common/components/Button';
import { media } from 'src/config/breakpoints';
import { UserCoursesBlankHeaderImage } from 'src/common/images/UserCoursesBlankHeaderImage';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { SearchRoute } from 'src/search/routes';

const ButtonContainer = styled.div`
  margin-top: 1.25rem;

  ${media.w.min.px992(css`
    margin-top: 1.875rem;
  `)};
`;

const Content = styled.div`
  padding-bottom: 2.5rem;
  text-align: center;

  ${media.w.min.px576(css`
    display: flex;
    text-align: left;
  `)};
`;

const Image = styled.div`
  flex: 1 0 42%;
  margin-bottom: -12vw;

  ${media.w.max.px576(css`
    display: none;
  `)};

  ${media.w.min.px768(css`
    flex-basis: 38.8%;
    margin-bottom: -11vw;
    margin-top: 3.25rem;
  `)};

  ${media.w.min.px992(css`
    flex: 0 0 21.875rem;
    margin-bottom: -4.5rem;
  `)};

  ${media.w.min.px1200(css`
    margin-right: 5.375rem;
  `)};
`;

const Text = styled.div`
  color: ${colors.blue};
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1rem;
  line-height: 1.375rem;
  margin-top: 1.875rem;

  ${media.w.min.px768(css`
    font-size: 1.5rem;
    line-height: 1.875rem;
  `)};

  ${media.w.min.px992(css`
    margin-top: 6.875rem;
  `)};
`;

export const UserCoursesHeaderBlank: FC = () => (
  <Content>
    <div>
      <Text>Rozpocznij szkolenia i&nbsp;patrz jak szybko wspinasz się po drabinie rozwoju</Text>

      <ButtonContainer>
        <Button as={GatsbyLink} to={SearchRoute}>
          Odkrywaj szkolenia
        </Button>
      </ButtonContainer>
    </div>

    <Image>
      <UserCoursesBlankHeaderImage />
    </Image>
  </Content>
);
